import { RecaptchaProvider } from '@/lib/recaptcha'

import { View } from './_view'

export const Contact = () => {
  return (
    <RecaptchaProvider>
      <View />
    </RecaptchaProvider>
  )
}
